export const EVENT_TYPE_WIDTH = 22;
